import "../PayPortal.css";

export default function SecurityPage() {
  return (
    <main className="pay-page">
      <section className="pay-review">
        <div className="pay-pills">
          <span>Sicherheit</span>
          <span>Pay Portal</span>
        </div>

        <h1>Ihre Zahlung ist sicher</h1>

        <p className="pay-text">
          Ihre Zahlung wird verschlüsselt übertragen und über unseren
          Zahlungsdienstleister Stripe verarbeitet.
        </p>

        <div className="pay-review-card">
          <h2>Sichere Zahlungsabwicklung</h2>
          <p>✓ SSL/TLS-verschlüsselte Verbindung</p>
          <p>✓ Zahlungsabwicklung über Stripe</p>
          <p>✓ Keine Speicherung vollständiger Kreditkartendaten bei DI Direkt Inkasso</p>
          <p>✓ Geschützte Verarbeitung Ihrer Zahlungs- und Vorgangsdaten</p>
          <p>✓ Nutzung ausschließlich zur Zahlungsabwicklung und Zuordnung Ihres Vorgangs</p>

          <h2>Kontakt bei Fragen</h2>
          <p>
            DI Direkt Inkasso GmbH<br />
            E-Mail: info@direkt-inkasso.de<br />
            Website: www.direkt-inkasso.de
          </p>
        </div>

        <button
          type="button"
          className="pay-button secondary"
          onClick={() => {
            window.location.href = "/";
          }}
        >
          Zurück zum Pay Portal
        </button>
      </section>
    </main>
  );
}